<template>
  <div class="about">
    <!-- start header -->
    <div class="header">
      <div class="layer">
        <div class="container">
          <div class="headInfo">
            <h6>HELLO TRAVELLER</h6>
            <h1>Welcome to jumo!</h1>
            <p>just tell us about your destination and we are here for more details, your service and all what we care about is your saftey and comfort ...</p>
          </div>
        </div>
      </div>
    </div>
    <!-- end header -->
    <!-- start section 1 -->
    <div class="section1">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-4 col-md-6">
            <div class="aboutThing">
              <i class="fas fa-ad our"></i>
              <h4>advertising agency</h4>
              <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Excepturi dolor beatae placeat, totam odio doloremque</p>
              <i class="fas fa-angle-double-right end"></i>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="aboutThing">
              <i class="fas fa-dice-d6 our"></i>
              <h4>advertising agency</h4>
              <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Excepturi dolor beatae placeat, totam odio doloremque</p>
              <i class="fas fa-angle-double-right end"></i>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="aboutThing">
              <i class="fas fa-lightbulb our"></i>
              <h4>advertising agency</h4>
              <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Excepturi dolor beatae placeat, totam odio doloremque</p>
              <i class="fas fa-angle-double-right end"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end section 1 -->
    <!-- start section 2 -->
    <div class="section2">
      <div class="container">
        <h6>CLIENTS OPOINIONS</h6>
        <h2>What our clients says!</h2>
        <div class="row justify-content-center">
          <div class="col-lg-4 col-md-6">
            <div class="client">
              <img src="../assets/images/about/section2/one.jpg" alt="">
              <img src="../assets/images/about/section2/person1.jpg" class="person" alt="">
              <div class="content">
                <span class="first">By admin . 12 Nov, 2018 . in saftey</span>
                <h5>Lorem, ipsum dolor sit amet</h5>
                <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dignissimos, possimus placeat recusandae eaque</p>
              </div>
              <div class="divFooter">
                <span><i class="fas fa-comment"></i>  25</span>
                <span><i class="fas fa-heart"></i>  250</span>
                <span><i class="fas fa-share"></i>  SHARE</span>
                <span class="more">MORE</span>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="client">
              <img src="../assets/images/about/section2/three.jpg" alt="">
              <img src="../assets/images/about/section2/person2.jpg" class="person" alt="">
              <div class="content">
                <span class="first">By admin . 12 Nov, 2018 . in saftey</span>
                <h5>Lorem, ipsum dolor sit amet</h5>
                <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dignissimos, possimus placeat recusandae eaque</p>
              </div>
              <div class="divFooter">
                <span><i class="fas fa-comment"></i>  75</span>
                <span><i class="fas fa-heart"></i>  450</span>
                <span><i class="fas fa-share"></i>  SHARE</span>
                <span class="more">MORE</span>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="client">
              <img src="../assets/images/about/section2/four.jpg" alt="">
              <img src="../assets/images/about/section2/person3.jpg" class="person" alt="">
              <div class="content">
                <span class="first">By admin . 12 Nov, 2018 . in saftey</span>
                <h5>Lorem, ipsum dolor sit amet</h5>
                <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dignissimos, possimus placeat recusandae eaque</p>
              </div>
              <div class="divFooter">
                <span><i class="fas fa-comment"></i>  37</span>
                <span><i class="fas fa-heart"></i>  342</span>
                <span><i class="fas fa-share"></i>  SHARE</span>
                <span class="more">MORE</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end section 2 -->
    <!-- start section 3 -->
    <div class="section3">
      <div class="layer">
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <div class="features1">
                <h2>Our awesome features..</h2>
                <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Cum maxime aut quam, assumenda aspernatur fugiat suscipit dicta quidem culpa libero facere</p>
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="one">
                      <h4>CLIENTS TRUST</h4>
                      <div id="uniqueID"></div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="one">
                      <h4>TRAVELLERS SAFETY</h4>
                      <div id="uniqueID2"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="infoo">
                <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Cumque, blanditiis, quia delectus cupiditate nihil ipsam pariatur odio veritatis eveniet voluptatem sapiente tempora ea molestias earum voluptatibus. Quibusdam aut placeat quos.</p>
                <div class="manager">
                  <img src="../assets/images/about/section3/manager.jpg" alt="">
                  <div class="manInfo">
                    <h6>jack nilson</h6>
                    <p>Manager</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end section 3 -->
    <!-- start section 4 -->
    <div class="section4">
      <div class="container">
        <div class="row">
          <div class="col-lg-4">
            <div class="ceo">
              <div class="ceoImg">
                <img src="../assets/images/about/section4/man.jpg" alt="">
              </div>
              <div class="cont">
                <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Voluptatibus tempora excepturi eum reiciendis aliquid animi recusandae, perferendis ab</p>
                <div class="links">
                  <div class="lin">
                    <span><i class="fas fa-comment"></i>  75</span>
                    <span><i class="fas fa-heart"></i>  450</span>
                    <span><i class="fas fa-eye"></i>  343</span>
                  </div>
                  <button>read more</button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="middle">
              <h3>Leaders portfolio</h3>
              <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Saepe adipisci tenetur, in quos suscipit expedita aperiam</p>
              <h2>002</h2>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="ceoAssistant">
              <div class="ceoImg">
                <img src="../assets/images/about/section4/woman.jpg" alt="">
              </div>
              <div class="cont">
                <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Voluptatibus tempora excepturi eum reiciendis aliquid animi recusandae, perferendis ab</p>
                <div class="links">
                  <div class="lin">
                    <span><i class="fas fa-comment"></i>  75</span>
                    <span><i class="fas fa-heart"></i>  450</span>
                    <span><i class="fas fa-eye"></i>  762</span>
                  </div>
                  <button>read more</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end section 4 -->
    <!-- start footer -->
    <app-footer></app-footer>
    <!-- end footer -->
  </div>
</template>

<style scoped lang='scss'>
@import '../css/variables.scss';
@import '../css/mixins.scss';
/* start header */
.header {
  background: url('../assets/images/about/header/four.jpg') no-repeat center /cover fixed;
  height: 100vh;
  margin-top: -16px;
  .layer {
    background-color: rgba(0, 0, 0, 0.6);
    height: 100vh;
    .headInfo {
      background-color: rgba(0, 0, 0, 0.5);
      position: absolute;
      width: 50%;
      right: 10%;
      top: 30%;
      color: #fff;
      padding: 30px;
      h1 {
        font-weight: 500;
        font-size: 50px;
        margin-bottom: 20px;
        letter-spacing: 2px;
      }
      p {
        font-size: 20px;
        color: rgb(231, 229, 229);
      }
    }
  }
  /* start media query of header */
  @include mb {
    .layer {
      .headInfo {
        top: 30%;
        left: 2%;
        width: 95%;
        margin: auto;
        padding: 40px 10px;
        h6 {
          font-size: 10px;
        }
        h1 {
          font-size: 25px;
        }
        p {
          font-size: 15px;
        } 
      }
    }
  }
  @include sm {
    .layer {
      .headInfo {
        top: 30%;
        right: 2%;
        width: 60%;
        margin: auto;
        padding: 40px 20px;
        h6 {
          font-size: 13px;
        }
        h1 {
          font-size: 40px;
        }
        p {
          font-size: 15px;
        } 
      }
    }
  }
  @include md {
    .layer {
      .headInfo {
        top: 30%;
        right: 2%;
        width: 60%;
        margin: auto;
        padding: 40px 30px;
        h6 {
          font-size: 13px;
        }
        h1 {
          font-size: 45px;
        }
        p {
          font-size: 17px;
        } 
      }
    }
  }
  /* end media query of header */
}
/* end header */
/* start section 1 */
.section1 {
  .aboutThing {
    text-align: left;
    position: relative;
    background-color: #fff;
    transform: translateY(-20px);
    padding: 30px;
    box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.2);
    width: 95%;
    margin: auto;
    i.our {
      font-size: 40px;
      color: $secondcolor;
      margin-bottom: 20px;
      position: absolute;
      top: 0;
      left: 40%;
      width: 75px;
      height: 75px;
      text-align: center;
      line-height: 75px;
      border-radius: 50%;
      transform: translateY(-66px);
      background-color: #fff;
    }
    h4 {
      margin-top: 10px;
      margin-bottom: 10px;
      font: {
        weight: bold;
        size: 22px;
      }
    }
    p {
      font-size: 15px;
      color: $textcolor;
    }
    i.end {
      position: absolute;
      bottom: -8%;
      right: 5%;
      width: 45px;
      height: 45px;
      line-height: 45px;
      background-color: $maincolor;
      color: #fff;
      text-align: center;
      font-size: 22px;
      border-radius: 50%;
      border: 1px solid $maincolor;
      cursor: pointer;
      &:hover {
        background-color: #fff;
        color: $maincolor;
        border: 1px solid $maincolor;
      }
    }
  }
  /* start media od section 1 */ 
  @include mb {
    .aboutThing {
      margin-bottom: 100px;
      i.our {
        box-shadow: 0px 5px 30px rgba(0, 0, 0, 0.1);
        font-size: 35px;
        width: 65px;
        height: 65px;
        line-height: 65px;
        transform: translateY(-60px);
      }
      h4 {
        font-size: 20px;
      }
      p {
        font-size: 13px;
      }
      i.end {
        width: 35px;
        height: 35px;
        line-height: 35px;
        font-size: 20px;
      }
    }
  }
  @include sm {
    .aboutThing {
      margin-bottom: 100px;
      i.our {
        box-shadow: 0px 5px 30px rgba(0, 0, 0, 0.1);
        font-size: 40px;
        width: 65px;
        height: 65px;
        line-height: 65px;
        transform: translateY(-60px);
      }
      i.end {
        width: 40px;
        height: 40px;
        line-height: 40px;
        font-size: 20px;
      }
    }
  }
  @include md {
    .aboutThing {
      margin-bottom: 100px;
      i.our {
        box-shadow: 0px 5px 30px rgba(0, 0, 0, 0.1);
        font-size: 35px;
        width: 65px;
        height: 65px;
        line-height: 65px;
        transform: translateY(-60px);
      }
      h4 {
        font-size: 20px;
      }
      p {
        font-size: 13px;
      }
      i.end {
        width: 40px;
        height: 40px;
        line-height: 40px;
        font-size: 20px;
      }
    }
  }
  /* end media of section 1 */
}
/* end section 1 */
/* start section 2 */
.section2 {
  margin-top: 150px;
  h6 {
    color: $maincolor;
    font: {
      weight: bold;
      size: 14px;
    }
  }
  h2 {
    margin-bottom: 80px;
    color: $secondcolor;
    font-weight: bold;
  }
  .client {
    text-align: left;
    border: 1px solid rgb(230, 227, 227);
    img {
      width: 100%;
      margin-bottom: 50px;
      filter: brightness(0.8);
      height: 220px;
    }
    img.person {
      width: 90px;
      height: 90px;
      border-radius: 50%;
      position: absolute;
      top: 36%;
      left: 10%;
      border: 5px solid #fff;
      filter: brightness(1)
    }
    .content {
      padding: 10px 20px 10px 20px;
      span.first {
        color: $textcolor;
        font-size: 14px;
        font-weight: bold;
      }
      h5 {
        color: $secondcolor;
        margin-top: 5px;
        font-weight: bold;
      }
      p {
        color: $textcolor;
        font-size: 15px;
      }
    }
    .divFooter {
      background-color: #e3f1ff;
      padding: 15px;
      span {
        margin-right: 2%;
        font-size: 12px;
        background-color: #fff;
        padding: 8px;
        border-radius: 10px;
        color: rgb(122, 122, 122);
        cursor: pointer;
        &.more {
          margin-left: 20%;
        }
        &:hover {
          background-color: $secondcolor;
          color: #fff;
        }
      }
    }
  }
  /* start media query of section 2 */ 
  @include mb {
    margin-top: 50px;
    h6 {
      font-size: 10px;
    }
    h2 {
      font-size: 25px;
      margin-bottom: 40px;
    }
    .client {
      margin-bottom: 70px;
      img {
        margin-bottom: 50px;
      }
      img.person {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        position: absolute;
        top: 33%;
      }
      .content {
        padding: 5px 10px 5px 10px;
        span.first {
          font-size: 11px;
        }
        h5 {
          font-size: 18px;
        }
        p {
          font-size: 12px;
        }
      }
      .divFooter {
        background-color: #e3f1ff;
        padding: 10px;
        span {
          margin-right: 1%;
          font-size: 9px;
          background-color: #fff;
          padding: 8px;
          border-radius: 10px;
          color: rgb(122, 122, 122);
          cursor: pointer;
          &.more {
            margin-left: 20%;
          }
          &:hover {
            background-color: $secondcolor;
            color: #fff;
          }
        }
      }
    }
  }
  @include sm {
    .client {
      margin-bottom: 70px;
      img {
        margin-bottom: 50px;
      }
      img.person {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        position: absolute;
        top: 34%;
      }
      .content {
        padding: 5px 15px 5px 15px;
        span.first {
          font-size: 13px;
        }
        h5 {
          font-size: 20px;
        }
        p {
          font-size: 13px;
        }
      }
      .divFooter {
        background-color: #e3f1ff;
        padding: 10px;
        span {
          margin-right: 3%;
          font-size: 10px;
        }
      }
    }
  }
  @include md {
    .client {
      margin-bottom: 70px;
      img {
        margin-bottom: 30px;
      }
      img.person {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        position: absolute;
        top: 35%;
      }
      .content {
        padding: 5px 10px 5px 10px;
        span.first {
          font-size: 11px;
        }
        h5 {
          font-size: 18px;
        }
        p {
          font-size: 12px;
        }
      }
      .divFooter {
        background-color: #e3f1ff;
        padding: 10px;
        span {
          margin-right: 1%;
          font-size: 9px;
          background-color: #fff;
          padding: 8px;
          border-radius: 10px;
          color: rgb(122, 122, 122);
          cursor: pointer;
          &.more {
            margin-left: 20%;
          }
          &:hover {
            background-color: $secondcolor;
            color: #fff;
          }
        }
      }
    }
  }
  /* end media query of section 2 */ 
}
/* end section 2 */
/* start section 3 */ 
.section3 {
  margin-top: 150px;
  background: url('../assets/images/about/section3/back3.jpg') no-repeat center /cover fixed;
  .layer {
    background-color: rgba(0, 0, 0, 0.7);
    height: 100%;
    color: #fff;
    .features1 {
      padding-bottom: 100px;
      h2 {
        padding-top: 100px;
        margin-bottom: 30px;
        font-size: 40px;
      }
      p {
        font-size: 20px;
        color: rgb(226, 226, 226);
      }
      h4 {
        font-size: 18px;
        margin-top: 40px;
      }
      #uniqueID, #uniqueID2 {
        font-size: 30px;
        margin-top: 20px;
      }
    }
    .infoo {
      background-color: rgba(0, 0, 0, 0.5);
      margin-top: 150px;
      padding: 40px;
      text-align: left;
      p {
        font-size: 18px;
      }
      .manager {
        display: flex;
        img {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          margin-right: 10px;
        }
        .manInfo {
          margin-top: 10px;
          h6 {
            font-weight: bold;
            letter-spacing: 1px;
            color: $maincolor;
            font-size: 18px;
          }
          p {
            color: rgb(204, 201, 201);
            font-size: 15px;
            font-weight: bold;
            letter-spacing: 1px;
          }
        }
      }
    }
  }
  /* start media query of section 3 */ 
  @include mb {
    .layer {
      .features1 {
        padding-bottom: 0px;
        h2 {
          padding-top: 50px;
          font-size: 30px;
        }
        p {
          font-size: 15px;
        }
        h4 {
          font-size: 16px;
        }
        #uniqueID, #uniqueID2 {
          font-size: 20px;
          width: 200px;
          margin-left: auto;
          margin-right: auto;
        }  
      }
      .infoo {
        margin-top: 70px;
        padding: 20px;
        margin-bottom: 50px;
        p {
          font-size: 14px;
        }
        .manager {
          img {
            width: 60px;
            height: 60px;
          }
          .manInfo {
            margin-top: 5px;
            h6 {
              font-size: 15px;
            }
            p {
              font-size: 12px;
            }
          }
        }
      }
    }
  }
  @include sm {
    .layer {
      .features1 {
        padding-bottom: 0px;
        h2 {
          padding-top: 80px;
          font-size: 40px;
        }
        p {
          font-size: 18px;
        }
        h4 {
          font-size: 18px;
        }
        #uniqueID, #uniqueID2 {
          font-size: 25px;
          width: 250px;
          margin-left: auto;
          margin-right: auto;
        }  
      }
      .infoo {
        margin-top: 170px;
        padding: 30px;
        margin-bottom: 60px;
        p {
          font-size: 17px;
        }
        .manager {
          img {
            width: 70px;
            height: 70px;
          }
          .manInfo {
            margin-top: 7px;
            h6 {
              font-size: 17px;
            }
            p {
              font-size: 14px;
            }
          }
        }
      }
    }
  }
  @include md {
    .layer {
      .features1 {
        #uniqueID, #uniqueID2 {
          font-size: 20px;
        }  
      }
      .infoo {
        padding: 30px;
      }
    }
  }
  /* end media query of section 3 */
}
/* end section 3 */
/* start section 4 */ 
.section4 {
  margin-top: 150px;
  .ceo {
    box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);
    background-color: #fff;
    margin-top: 35%;
    .ceoImg {
      height: 50px;
      background-color: $secondcolor;
      margin-bottom: 40px;
      img {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        padding: 5px;
        margin-top: 15px;
        background-color: #fff;
      }
    }
    .cont {
      padding: 30px 20px;
      .links {
        margin-top: 30px;
        position: relative;
        padding-bottom: 30px;
        .lin {
          position: absolute;
          top: 0;
          left: 6%;
          width: 100%;
          transition: all 0.3s ease-in-out;
          span {
            margin-right: 10%;
            color: rgb(134, 134, 134);
            font-size: 14px;
            transition: all 0.3s ease-in-out;
          }
        }
        button {
          width: 120px;
          height: 40px;
          border-radius: 20px;
          background-color: $secondcolor;
          color: #fff;
          border: none;
          outline: none;
          position: absolute;
          top: -20%;
          left: 33%;
          opacity: 0;
          z-index: -1;
          transition: all 0.3s ease-in-out;
          transform: scale(0.1);
          &:hover {
            background-color: #fff;
            color: $secondcolor;
            border: 2px solid $secondcolor;
          }
        }
      }
    }
    &::after {
      content: '';
      position: absolute;
      border: 1px dashed $secondcolor;
      left: 97%;
      top: 58%;
      width: 140px;
      height: 2px;
    }
    &:hover {
      .links {
        .lin {
          opacity: 0;
          z-index: -1;
          span {
            font-size: 3px;
            margin-right: 1%;
          }
        }
        button {
          opacity: 1;
          z-index: 1;
          transform: scale(1);
        }
      }
    }
  }
  .middle {
    background-color: #e3f1ff;
    position: relative;
    z-index: -1;
    width: 200%;
    margin-left: -50%;
    height: 500px;
    h3 {
      padding-top: 30px;
      font-size: 40px;
    }
    p {
      width: 50%;
      margin: auto;
    }
    h2 {
      width: 130px;
      height: 130px;
      background-color: #fff;
      margin: 10% auto;
      border-radius: 50%;
      line-height: 120px;
      color: $maincolor;
      border: 4px solid $secondcolor;
      font-weight: bold;
      font-size: 35px;
    }
  }
  .ceoAssistant {
    box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);
    background-color: #fff;
    margin-top: 35%;
    .ceoImg {
      height: 50px;
      background-color: $secondcolor;
      margin-bottom: 40px;
      img {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        padding: 5px;
        margin-top: 15px;
        background-color: #fff;
      }
    }
    .cont {
      padding: 30px 20px;
      .links {
        margin-top: 30px;
        position: relative;
        padding-bottom: 30px;
        .lin {
          position: absolute;
          top: 0;
          left: 6%;
          width: 100%;
          transition: all 0.3s ease-in-out;
          span {
            margin-right: 10%;
            color: rgb(134, 134, 134);
            font-size: 14px;
            transition: all 0.3s ease-in-out;
          }
        }
        button {
          width: 120px;
          height: 40px;
          border-radius: 20px;
          background-color: $secondcolor;
          color: #fff;
          border: none;
          outline: none;
          position: absolute;
          top: -20%;
          left: 33%;
          opacity: 0;
          z-index: -1;
          transition: all 0.3s ease-in-out;
          transform: scale(0.1);
          &:hover {
            background-color: #fff;
            color: $secondcolor;
            border: 2px solid $secondcolor;
          }
        }
      }
    }
    &::before {
      content: '';
      position: absolute;
      border: 1px dashed $secondcolor;
      right: 97%;
      top: 58%;
      width: 140px;
      height: 2px;
    }
    &:hover {
      .links {
        .lin {
          opacity: 0;
          z-index: -1;
          span {
            font-size: 3px;
            margin-right: 1%;
          }
        }
        button {
          opacity: 1;
          z-index: 1;
          transform: scale(1);
        }
      }
    }
  }
  /* start media query of section 4 */ 
  @include mb {
    margin-top: 50px;
    .ceo {
      margin-top: 50px;
      margin-bottom: 50px;
      .ceoImg {
        img {
          width: 90px;
          height: 90px;
        }
      }
      .cont {
        p {
          font-size: 14px;
        }
        .links {
          margin-top: 10px;
          .lin {
            span {
              font-size: 12px;
            }
          }
          button {
            width: 80px;
            font-size: 11px;
            height: 35px;
          }
        }
      }
      &::after {
        border: none;
      }
    }
    .middle {
      z-index: 1;
      width: 100%;
      margin-left: 0%;
      padding-bottom: 30px;
      height: auto;
      h3 {
        padding-top: 30px;
        font-size: 25px;
      }
      p {
        width: 90%;
        font-size: 13px;
      }
      h2 {
        width: 100px;
        height: 100px;
        margin: 10% auto;
        line-height: 90px;
        border: 3px solid $secondcolor;
        font-weight: bold;
        font-size: 30px;
      }
    }
    .ceoAssistant {
      margin-top: 50px;
      margin-bottom: 50px;
      .ceoImg {
        img {
          width: 90px;
          height: 90px;
        }
      }
      .cont {
        p {
          font-size: 14px;
        }
        .links {
          margin-top: 10px;
          .lin {
            span {
              font-size: 12px;
            }
          }
          button {
            width: 80px;
            font-size: 11px;
            height: 35px;
          }
        }
      }
      &::before {
        border: none;
      }
    }
  }
  @include sm {
    margin-top: 50px;
    .ceo {
      margin-top: 50px;
      margin-bottom: 50px;
      width: 55%;
      margin-left: auto;
      margin-right: auto;
      .ceoImg {
        img {
          width: 100px;
          height: 100px;
        }
      }
      .cont {
        p {
          font-size: 16px;
        }
        .links {
          margin-top: 20px;
          .lin {
            span {
              font-size: 13px;
            }
          }
          button {
            width: 110px;
            font-size: 14px;
            height: 35px;
          }
        }
      }
      &::after {
        border: none;
      }
    }
    .middle {
      z-index: 1;
      width: 100%;
      margin-left: 0%;
      padding-bottom: 30px;
      height: auto;
      h3 {
        padding-top: 30px;
        font-size: 35px;
      }
      p {
        width: 80%;
        font-size: 16px;
      }
      h2 {
        width: 120px;
        height: 120px;
        margin: 5% auto;
        line-height: 110px;
        border: 4px solid $secondcolor;
        font-weight: bold;
        font-size: 35px;
      }
    }
    .ceoAssistant {
      margin-top: 50px;
      margin-bottom: 50px;
      width: 55%;
      margin-left: auto;
      margin-right: auto;
      .ceoImg {
        img {
          width: 100px;
          height: 100px;
        }
      }
      .cont {
        p {
          font-size: 16px;
        }
        .links {
          margin-top: 20px;
          .lin {
            span {
              font-size: 13px;
            }
          }
          button {
            width: 110px;
            font-size: 14px;
            height: 35px;
          }
        }
      }
      &::before {
        border: none;
      }
    }
  }
  @include md {
    .ceo {
      box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);
      background-color: #fff;
      margin-top: 35%;
      .ceoImg {
        height: 50px;
        background-color: $secondcolor;
        margin-bottom: 40px;
        img {
          width: 90px;
          height: 90px;
          border-radius: 50%;
          padding: 5px;
          margin-top: 15px;
          background-color: #fff;
        }
      }
      .cont {
        padding: 30px 20px;
        p {
          font-size: 15px;
        }
        .links {
          margin-top: 25px;
          position: relative;
          padding-bottom: 30px;
          .lin {
            position: absolute;
            top: 0;
            left: 6%;
            width: 100%;
            transition: all 0.3s ease-in-out;
            span {
              margin-right: 10%;
              color: rgb(134, 134, 134);
              font-size: 13px;
              transition: all 0.3s ease-in-out;
            }
          }
          button {
            width: 100px;
            height: 35px;
            top: -20%;
            left: 30%;
            font-size: 13px;
            &:hover {
              background-color: #fff;
              color: $secondcolor;
              border: 2px solid $secondcolor;
            }
          }
        }
      }
      &::after {
        content: '';
        position: absolute;
        border: 1px dashed $secondcolor;
        left: 97%;
        top: 54%;
        width: 100px;
        height: 2px;
      }
    }
    .middle {
      background-color: #e3f1ff;
      position: relative;
      z-index: -1;
      width: 200%;
      margin-left: -50%;
      height: 500px;
      h3 {
        padding-top: 30px;
        font-size: 35px;
      }
      p {
        font-size: 15px;
      }
      h2 {
        width: 130px;
        height: 130px;
        background-color: #fff;
        margin: 10% auto;
        border-radius: 50%;
        line-height: 120px;
        color: $maincolor;
        border: 4px solid $secondcolor;
        font-weight: bold;
        font-size: 35px;
      }
    }
    .ceoAssistant {
      box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);
      background-color: #fff;
      margin-top: 35%;
      .ceoImg {
        height: 50px;
        background-color: $secondcolor;
        margin-bottom: 40px;
        img {
          width: 90px;
          height: 90px;
          border-radius: 50%;
          padding: 5px;
          margin-top: 15px;
          background-color: #fff;
        }
      }
      .cont {
        padding: 30px 20px;
        p {
          font-size: 15px;
        }
        .links {
          margin-top: 25px;
          position: relative;
          padding-bottom: 30px;
          .lin {
            position: absolute;
            top: 0;
            left: 6%;
            width: 100%;
            transition: all 0.3s ease-in-out;
            span {
              margin-right: 10%;
              color: rgb(134, 134, 134);
              font-size: 13px;
              transition: all 0.3s ease-in-out;
            }
          }
          button {
            width: 100px;
            height: 35px;
            top: -20%;
            left: 30%;
            font-size: 13px;
            &:hover {
              background-color: #fff;
              color: $secondcolor;
              border: 2px solid $secondcolor;
            }
          }
        }
      }
      &::before {
        content: '';
        position: absolute;
        border: 1px dashed $secondcolor;
        right: 97%;
        top: 54%;
        width: 100px;
        height: 2px;
      }
    }
  }
  /* end media query of section 4 */
}
/* end section 4 */ 
</style>

<script>
import footer from '../components/footer'
import $ from 'jquery'
export default {
  data() {
    return {

    }
  },
  mounted() {
    window.scrollTo(0, 0);
    this.$store.state.Loading = true;
    setTimeout( () => {
      this.$store.state.Loading = false;
    }, 1000);
    var ProgressBar = require("progressbar.js");
    var opts = {
      strokeWidth: 5,
      easing: 'easeInOut',
      duration: 1000,
      color: '#fff',
      trailColor: '#454545',
      trailWidth: 1,
      svgStyle: {width: '50%', height: '100%'},
      step: function(state, circle) {
        circle.path.setAttribute('stroke', "#ff214f");
        var value = Math.round(circle.value() * 100);
        if (value === 0) {
          circle.setText('');
        } else {
          circle.setText(value + "%");
        }
      },
      transform: {
        prefix: true,
        value: 'translate(-50%, -50%)'
      },
    }
    var lineOne = new ProgressBar.Circle('#uniqueID', opts);
    var lineTwo = new ProgressBar.Circle('#uniqueID2', opts);
    $(window).on("scroll", function() {
      if($(window).scrollTop() >= $(".section3").offset().top - 250) {
        lineOne.animate(0.93)
        lineTwo.animate(0.76)
      }
    });
  },
  components: {
    'app-footer': footer
  }
}
</script>